<template>
  <path
    d="M18.5 12.0002C18.5 10.2302 17.48 8.71017 16 7.97017V16.0202C17.48 15.2902 18.5 13.7702 18.5 12.0002ZM5 10.0002V14.0002C5 14.5502 5.45 15.0002 6 15.0002H9L12.29 18.2902C12.92 18.9202 14 18.4702 14 17.5802V6.41017C14 5.52017 12.92 5.07017 12.29 5.70017L9 9.00017H6C5.45 9.00017 5 9.45017 5 10.0002Z"
  />
</template>
